/**
 * Meta Pixel event tracking utility for ScalitOS.
 * Fires standard and custom Facebook Pixel events.
 * Safe to call even if fbq is not loaded (e.g., ad blocker).
 * Deduplication: uses a Set to prevent the same event firing twice in a session.
 */

const _firedOnce = new Set();

function trackEvent(eventName, params = {}) {
  if (typeof window.fbq === 'function') {
    window.fbq('track', eventName, params);
  }
}

function trackEventOnce(eventName, params = {}) {
  const key = `${eventName}_${JSON.stringify(params)}`;
  if (_firedOnce.has(key)) return;
  _firedOnce.add(key);
  trackEvent(eventName, params);
}

function trackCustom(eventName, params = {}) {
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, params);
  }
}

/** Standard events — deduplicated */
export const pixelCompleteRegistration = () =>
  trackEventOnce('CompleteRegistration', { content_name: 'ScalitOS Signup', status: true });

export const pixelPurchase = (value, currency = 'USD', contentName = 'Credit Pack') =>
  trackEventOnce('Purchase', { value: parseFloat(value), currency, content_name: contentName });

export const pixelSubscribe = (tier, value = 0) =>
  trackEventOnce('Subscribe', { value: parseFloat(value), currency: 'USD', predicted_ltv: parseFloat(value), content_name: `${tier} Plan` });

export const pixelStartTrial = () =>
  trackEventOnce('StartTrial', { content_name: 'ScalitOS Free Trial' });

export const pixelInitiateCheckout = (value, currency = 'USD') =>
  trackEvent('InitiateCheckout', { value: parseFloat(value) || 0, currency, content_name: 'ScalitOS Credits' });

export const pixelLead = () =>
  trackEventOnce('Lead', { content_name: 'ScalitOS Signup' });

/** Custom events — allowed to repeat */
export const pixelVideoGenerated = () =>
  trackCustom('VideoGenerated', { content_category: 'Video Ad' });

export const pixelFlyerGenerated = (type = 'template') =>
  trackCustom('FlyerGenerated', { content_category: type });

export const pixelCharacterGenerated = (style) =>
  trackCustom('CharacterGenerated', { content_category: style });

export const pixelCarouselGenerated = () =>
  trackCustom('CarouselGenerated', { content_category: 'Carousel' });

export const pixelVoiceoverGenerated = () =>
  trackCustom('VoiceoverGenerated', { content_category: 'Voiceover' });

export const pixelContentGenerated = (type) =>
  trackCustom('ContentGenerated', { content_category: type });
